import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  httpErrorMessageEvent = new EventEmitter<any>();
  adCategoryMessageEvent = new EventEmitter<any>();
  adCategoryMapMessageEvent = new EventEmitter<any>();
  addExaminerMessageEvent = new EventEmitter<any>();
  gridDataLoadedEvent = new Subject<any>();

  constructor(public router: Router,) { }

  setErrID(id: string) {
    sessionStorage.setItem('errorId',id);
  }
  getErrID(){
    return sessionStorage.getItem('errorId');
  }
}
